import { render } from "./VehicleInfo.vue?vue&type=template&id=4c1e665a"
import script from "./VehicleInfo.vue?vue&type=script&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__